<template>
  <form @submit.prevent action>
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head">
        <p class="modal-card-title">Adicionar uma Conta</p>
      </header>

      <section class="modal-card-body">
        <b-field label="Nome da Conta">
          <b-input placeholder="Ex.: Conta Bancária" v-model="conta.nome"></b-input>
        </b-field>

        <div class="tile is-ancestor">
          <div class="tile is-vertical">
            <div class="tile">
              <div class="tile is-parent">
                <article class="tile is-child">
                  <b-field label="Saldo Inicial">
                    <money
                      v-model="conta.saldo_inicial"
                      v-bind="money"
                      class="input form-input input-lg"
                    >{{conta.saldo}}</money>
                  </b-field>
                </article>
              </div>

              <div class="tile is-parent">
                <article class="tile is-child">
                  <b-field label="Data de Abertura">
                    <b-datepicker
                      v-model="conta.data_criacao"
                      placeholder="Clique para selecionar..."
                      icon="calendar-today"
                      position="is-top-left"
                      :month-names="monthNames"
                      :day-names="dayNames"
                    ></b-datepicker>
                  </b-field>
                </article>
              </div>

            </div>
          </div>
        </div>
      </section>

      <footer class="modal-card-foot">
        <button class="button is-success is-small" @click="saveAccount()">Adicionar Conta</button>
        <button class="button is-danger is-small" @click="closeModal()">Cancelar</button>
      </footer>
    </div>
  </form>
</template>

<script>
export default {
  data() {
    return {
      conta: {
        _associacao: this.$cookies.get("IDASSOCIACAO"),
        _id: null,
        _transacoes: [],
        data_atualizacao: new Date(),
        data_criacao: new Date(),
        isActive: true,
        isDefault: false,
        nome: "",
        saldo: 0,
        saldo_inicial: 0
      },
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        suffix: " #",
        precision: 2,
        masked: false
      },
      monthNames: [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro"
      ],
      dayNames: ["D", "S", "T", "Q", "Q", "S", "S"]
    };
  },
  computed: {
    successAddConta() {
      return this.$store.getters["contas/getIsSuccess"];
    }
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },

    validateAccount() {
      if (!this.conta.nome.trim()) return "Adicione um Nome à Conta!";
      if (!this.conta.data_criacao) return "Adicione uma Data de Abertura!";
      return;
    },

    saveAccount() {
      let error = this.validateAccount();
      if (error) {
        this.$alert("Aviso!", error, "danger");
        return;
      }

      this.conta._id = this.stringRandomId(20);
      this.conta.saldo = this.conta.saldo_inicial;

      this.saveAccountOnDatabase();
    },

    async saveAccountOnDatabase() {
      const loadingComponent = this.$loading.open({
        container: null
      });

      await this.$store.dispatch("contas/addContaInFirestore", this.conta);
      loadingComponent.close();

      if (this.successAddConta) {
        this.$alert("Sucesso!", "Conta Adicionada!", "success");
        this.$store.commit("contas/setIsSuccess", false);
        this.closeModal();
      } else {
        this.$alert("Erro!", "Erro ao Atualizar Saldo!", "danger");
      }
    },

    stringRandomId(tamanho) {
      let letras = "ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz";
      let aleatorio = "";
      for (var i = 0; i < tamanho; i++) {
        var rnum = Math.floor(Math.random() * letras.length);
        aleatorio += letras.substring(rnum, rnum + 1);
      }
      return aleatorio;
    }
  },
  mounted() {}
};
</script>

<style scoped>
.modal .animation-content .modal-card {
  overflow: visible !important;
}

.modal-card-body {
  overflow: visible !important;
}

@media screen and (max-width: 1088px) {
  .modal .animation-content .modal-card {
    overflow: scroll !important;
  }
}
</style>
